import AppEvents from 'Shared/app-events';
import CartApi from 'Api/cart-api';
import BookmarkApi from 'Api/bookmark-api';
import CompareApi from 'Api/compare-api';

import Util from 'Common/util';

class CartItem {
    constructor(module, data) {
        this.module = module;

        ko.mapping.fromJS(data, this.#mapping, this);
    }

    #mapping = {};

    addToCompare = (model, e) => {
        const element = e.currentTarget;

        Util.startLoading(element);

        CompareApi.addProduct(model.ProductId())
            .then(() => {
                AppEvents.emit("aside.compare.show");
            })
            .finally(() => {
                Util.stopLoading(element);
            });
    }

    addToBookmarks = (model, e) => {
        const element = e.currentTarget;

        Util.startLoading(element);

        BookmarkApi.addItem(model.ProductId())
            .then(() => {
                AppEvents.emit("aside.bookmark.show");
            })
            .finally(() => {
                Util.stopLoading(element);
            });
    }

    comment = (model, e) => {
        const element = e.currentTarget;

        Util.startLoading(element);

        CartApi.commentItem(model.Id());

        Util.stopLoading(element);
    }
}

export default class CartModule {

    constructor(data, view) {
        this.view = view;

        ko.mapping.fromJS(data, this.#mapping, this);

        this.loaded(true);
    }

    #mapping = {
        Items: {
            key: (data) => ko.utils.unwrapObservable(data.Id),
            create: (options) => new CartItem(this, options.data)
        }
    };

    loading = ko.pureComputed(() => this.view.contextLoading());
    loaded = ko.observable(false);

    Items = ko.observableArray([]);

    index = ko.pureComputed({
        read: () => this.Carts().findIndex(x => x.Id() == this.CartId()),
        write: (value) => {
            this.indexChange(this.Carts()[value]);
        },
        owner: this
    });

    template = ko.computed(() => "cart-container-tpl");

    hasItems = ko.pureComputed(() => this.loaded() && this.ItemCount());

    indexChange = (data) => {
        this.loading(true);
        CartApi.select(data.Id);
    }

    selected = ko.computed(() => this.Carts().find(x => x.Id() == this.CartId()));

    hasPrev = ko.pureComputed(() => this.loaded() && this.index() > 0);
    prev = () => {
        CartApi.select(this.Carts()[this.index() - 1].Id());
    }

    hasNext = ko.pureComputed(() => this.loaded() && this.index() < this.Carts().length - 1);
    next = () => {
        CartApi.select(this.Carts()[this.index() + 1].Id());
    }

    removeItem = (model, e) => {
        Util.startLoading(e.currentTarget);
        CartApi.deleteItem(model.Id());
    }

    fadeIn = element => {
        if (element.nodeType === 1) {
            $(element).hide().fadeIn();
        }
    };

    fadeOut = element => {
        if (element.nodeType === 1) {
            $(element).fadeOut(() => $(element).remove());
        }
    };

    dispose() {}
}